import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ChipIcon from "./ChipIcon";

// Define color themes based on status
const statusColors = {
  disable: {
    background: "#E9ECEF",
    color: "#6C757D",
  },
  warning: {
    background: "#FEECCF",
    color: "#FC9E11",
  },
  danger: {
    background: "#FBD5D6",
    color: "#EC2D30",
  },
  info: {
    background: "#E0EDF7",
    color: "#0065C0",
  },
  success: {
    background: "#DDF9E5",
    color: "#049F2F",
  },
};

// Styled component for Chip
const ChipWrapper = styled.div`
  display: inline-flex;
  min-height: 20px;
  height: auto;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 100px;
  background-color: ${(props) => statusColors[props.$status].background};
  color: ${(props) => statusColors[props.$status].color};
  font-weight: 500;
  font-size: 16px;
  line-height: 1.2;
  gap: 8px;
  white-space: pre-wrap;
  word-break: break-word;
`;

const ChipStatus = ({
  status = "disable",
  children,
  autoDismiss = true, // default: hide itself
  duration = 1500, // ms before auto-hide can reset if needed in the calling place
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!autoDismiss) return; // opt-out if needed
    const t = setTimeout(() => {
      setVisible(false);
    }, duration);
    return () => clearTimeout(t);
    // re-arm timer if status/children change
  }, [status, children, autoDismiss, duration]);

  if (!visible) return null;

  return (
    <ChipWrapper $status={status}>
      <ChipIcon color={statusColors[status].color} status={status} />
      {children}
    </ChipWrapper>
  );
};

export default ChipStatus;
